import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Avatar, Grid, Chip, Typography, Button, CircularProgress, Pagination } from '@mui/material';
import { DataGrid } from "@mui/x-data-grid";
import ApiService from '../../functions/apiService';
import moment from 'moment';
import './position-assign.css'
import { toast } from 'react-toastify';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Modal from 'react-bootstrap/Modal';
import { Col, Row } from 'react-bootstrap';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';

const CancelledAssignments = ({ embedded = false }) => {
  const { user } = useContext(AuthContext);
  const timeFormat = (timeStr) => timeStr?.slice(0, 5);
  const [loading, setLoading] = useState(false);
  const [assignmentList, setAssignmentList] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [reasonModal, setReasonModal] = useState(false);
  const [reason, setReason] = useState('');
  const [allowedVars, setAllowedVars] = useState({});
  const [absentReason, setAbsentReason] = useState('');
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [rejectAllowed, setRejectAllowed] = useState(false);
  const [rejectId, setRejectId] = useState('')
  const [rejectStatus, setRejectStatus] = useState('')

  let getAllowedVars = () => {
    ApiService.get('/v3Variables')
      .then((res) => {
        setAllowedVars(res?.data?.data)
      }).catch(({ error }) => {
        console.log('error', error)
      });
  }

  useEffect(() => {
    getAllowedVars()
  }, [])

  const checkButtonStyle = {
    color: "#555555",
    minWidth: "0",
    paddingRight: ".02rem",
    ":hover": { color: "green", background: "none" },
  };

  const clearButtonStyle = {
    color: "#555555",
    minWidth: "0",
    paddingRight: ".02rem",
    ":hover": { color: "red", background: "none" },
  };

  const columns = [
    {
      field: 'Assignment_date', headerName: 'Date', flex: 1, minWidth: 160,
      valueGetter: (params) => {
        return moment(params?.row?.Shift_Date).format('ddd Do MMM YYYY');
      }
    },

    {
      field: 'name', headerName: 'Name', flex: 1, minWidth: 200,
      valueGetter: (params) => {
        return (params?.row?.employee?.employee_assignment?.EA_Rank + " " + params?.row?.employee?.fullName)
      }
    },

    {
      field: 'Shift', headerName: 'Shift', flex: 1, minWidth: 200,
      renderCell: (params) => {
        return <Chip
          sx={{
            height: 'auto',
            '& .MuiChip-label': {
              display: 'block',
              whiteSpace: 'normal',
            },
          }}
          style={{
            textAlign: 'center',
            padding: '6px 0px',
            width: '90%',
            color: '#2E3238',
            fontSize: '12px',
            backgroundColor: params.row.ShiftCode === "2" || params.row.Shift_Code == 2 ? 'rgba(255, 165, 0, 0.26)' : 'rgba(52, 152, 219, 0.16)',
            border: params.row.ShiftCode === "2" || params.row.Shift_Code == 2 ? '1px solid rgba(255, 165, 0, 0.28)' : '1px solid rgba(52, 152, 219, 0.2)'
          }}
          label={`${(params?.row?.Shift_Code == '2') ? 'DAY' : (params?.row?.Shift_Code == '3') ? 'NIGHT' : "EVENING"} (${varFormatTime(timeFormat(params?.row?.Start_Time), user?.Time_Format)} - ${varFormatTime(timeFormat(params?.row?.End_Time), user?.Time_Format)})`}
        />;
      },
    },

    {
      field: 'Position', headerName: 'Position', flex: 1, minWidth: 140,
      renderCell: (params) => (
        <Chip
          sx={{
            height: 'auto',
            '& .MuiChip-label': {
              display: 'block',
              whiteSpace: 'normal',
            },
          }}
          style={{
            textAlign: 'center',
            padding: '6px 0px',
            width: '100%',
            color: '#2E3238',
            fontSize: '12px',
          }}
          label={params?.row?.position_assignments?.position_name?.SO_Desc}
        />
      ),
    },

    {
      field: 'Assignment', headerName: 'Assignment', flex: 1, minWidth: 140,
      renderCell: (params) => {
        return (params?.row?.position_assignments?.assignment_name?.SO_Desc)
      }
    },

    {
      field: '24Hours', headerName: 'Cancellation', flex: 1, minWidth: 140,
      renderCell: (params) => {
        return (params?.row?.IsWithin24Hours == true ?
          <Chip style={{ width: '125px' }}
            color={'warning'}
            label={`Within ${allowedVars?.V3_VOLUNTEER_CANCELLATION_TIMEFRAME} hours`} />
          : '')
      }
    },

    // {
    // 	field: 'reason', headerName: '', flex: 1, minWidth: 180,
    // 	renderCell: (params) => {
    // 		return (params?.row?.Reason)
    // 	}
    // },

    {
      field: "reason",
      headerName: "Reason",
      flex: 1,
      minWidth: 60,
      renderCell: (params) => {
        const rejectReason = params?.row?.Reason;
        const absentCode = params?.row?.Absent_Code;
        return (
          <>
            {rejectReason &&
              <Button
                onClick={() => {
                  setRejectAllowed(false)
                  setReason(rejectReason);
                  setAbsentReason(absentCode || '')
                  setTimeout(() => setReasonModal(true), 500);
                }}
                sx={checkButtonStyle}
                startIcon={
                  <Avatar
                    src="/images/eye.svg"
                    style={{ width: 28, height: 24, padding: 1, marginLeft: '6px' }}
                  />
                }
              />
            }
          </>
        );
      },
    },

    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      minWidth: 80,
      renderCell: (params) => {
        const rejectReason = params?.row?.Reason;
        const absentCode = params?.row?.Absent_Code;
        return params?.row?.Status === 'pending' ? (
          <>
            <Button
              onClick={() => shiftAction(params?.row?.ID, 'accepted')}
              sx={checkButtonStyle}
              startIcon={<CheckIcon />}
            ></Button>

            <Button
              // onClick={() => shiftAction(params?.row?.ID, 'rejected')}
              onClick={() => {
                setRejectId(params?.row?.ID)
                setRejectStatus('rejected')
                setRejectAllowed(true)
                setReason(rejectReason);
                setAbsentReason(absentCode || '')
                setTimeout(() => setReasonModal(true), 500);
              }}

              sx={clearButtonStyle}
              startIcon={<ClearIcon />}
            ></Button>
          </>
        ) : params?.row?.Status === 'accepted' ? (
          <Chip style={{ width: '80px' }}
            color={'DarkGreen'}
            label={"Accepted"} />
        ) : (
          <Chip style={{ width: '80px' }}
            color={'primary'}
            label={"Rejected"} />
        );
      },
    }
  ]

  const getAssignmentList = () => {
    setLoading(true)
    ApiService.post(`/positionAssignmentFillCancelRequestsList?page=${currentPage}`, {
      "from_date": fromDate ? moment(fromDate).format('YYYY-MM-DD') : "",
      "to_date": toDate ? moment(toDate).format('YYYY-MM-DD') : ""
    })
      .then(({ data }) => {
        setAssignmentList(data?.data);
        setTotalPages(Math.ceil(data?.total / data?.per_page));
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  }

  const handlePageChange = (_, value) => {
    setCurrentPage(value);
  }

  const shiftAction = (id, status) => {
    ApiService.post("/updatePositionAssignmentFillCancelRequestsStatus", {
      "Position_Assignments_Fill_Id": rejectId ? rejectId : id,
      "Status": rejectStatus ? rejectStatus : status
    })
      .then((data) => {
        setReasonModal(false)
        setRejectId('')
        setRejectStatus('')
        toast.success(data?.message)
        getAssignmentList(false)
      })
      .catch((error) => {
        toast.error(error?.data?.message)
      });
  }

  useEffect(() => {
    getAssignmentList()
  }, [fromDate, toDate, currentPage])

  const AssignmentExport = () => {
    ApiService.post(
      "/position-assignment-requests/export",
      {
        "from_date": fromDate ? moment(fromDate).format('YYYY-MM-DD') : "",
        "to_date": toDate ? moment(toDate).format('YYYY-MM-DD') : ""
      },
      { responseType: "blob" }
    )
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res], { type: "text/csv" })
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "assignment_export.csv");
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Export error", error);
      });
  };


  return (
    <>
      {loading ? (
        <Box className="w-100 d-flex justify-content-center align-items-center font-fam" sx={{ minHeight: embedded ? 260 : 400 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper elevation={embedded ? 0 : 1} className={embedded ? "font-fam" : "p-4 font-fam"} style={embedded ? { fontFamily: 'Karla' } : { marginTop: "1rem" }}>
          <Grid container spacing={2} alignItems="center" className={embedded ? '' : 'mt-2'}>

            {!embedded && (
              <Grid item xs={10} md={6.5} sm={12}>
                <Typography variant="h5">Cancelled Assignments</Typography>
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={embedded ? 3 : 2} className='d-grid'>
              <label>From Date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <ButtonDatePicker
                  className='w-100'
                  label={fromDate ? moment(fromDate).format('MM/DD/YYYY') : 'MM/DD/YYYY'}
                  value={fromDate}
                  onChange={(e) => setFromDate(e)}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={embedded ? 3 : 2} className='d-grid'>
              <label>To Date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <ButtonDatePicker
                  className='w-100'
                  label={toDate ? moment(toDate).format('MM/DD/YYYY') : 'MM/DD/YYYY'}
                  value={toDate}
                  onChange={(e) => setToDate(e)}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={embedded ? 2 : 1.5} className='d-grid' sx={{ alignSelf: embedded ? 'end' : 'auto' }}>
              <ButtonTheme
                color="primary"
                onClick={AssignmentExport}
                disabled={assignmentList.length == 0}
              >
                Export
              </ButtonTheme>
            </Grid>

          </Grid>

          {(!assignmentList || assignmentList.length == 0) ?
            <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: embedded ? 280 : 565 }}>
              <img src='/images/blur-logo.png' style={{ height: embedded ? 140 : 200, width: embedded ? 175 : 250 }} />
              <span className='mt-4' style={{ color: '#555555' }}>
                No Cancelled Assignments Found
              </span>
            </div>
            :
            <>
              <div className='mt-3'>
                <DataGrid
                  rows={assignmentList}
                  columns={columns}
                  checkboxSelection={false}
                  hideFooter={true}
                  autoHeight
                  getRowId={assignmentList?.id}
                  sx={{
                    fontFamily: 'Karla',
                    border: '1px solid #EAECF0',
                    borderRadius: '10px',
                    '& .MuiDataGrid-columnHeaders': {
                      backgroundColor: '#F9FAFB',
                      fontWeight: 600,
                    },
                    '& .MuiDataGrid-cell': {
                      display: 'flex',
                      alignItems: 'center',
                    },
                    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                      outline: 'none',
                    },
                    '& .MuiDataGrid-row:hover': {
                      backgroundColor: 'rgba(191, 29, 45, 0.03)',
                    },
                  }}
                />
              </div>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                className="mt-3 d-flex"
                style={{ justifyContent: 'end' }}
              />
            </>
          }
        </Paper >
      )}

      {/* Reason Modal */}
      <Modal show={reasonModal} size="md"
        onHide={() => { setReasonModal(false) }}>
        <Modal.Header closeButton>
          <Modal.Title>{rejectAllowed === true ? "Cancel Request" : "Reason for Cancellation"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {rejectAllowed === true &&
            <div className='mb-3' style={{ color: '#555555' }}>
              Are you sure you want to reject the request for this User
              <br></br>
              on this Shift?
            </div>}
          <Row className='w-100 m-auto' style={{ flexWrap: 'wrap' }}>
            {reason &&
              <div className="p-0" style={{ color: '#000', marginBottom: '4px' }}>
                Reason : {reason ? reason : ''}
              </div>
            }
            {absentReason &&
              <div className="p-0" style={{ color: '#000', marginBottom: '12px' }}>
                Absent Code : {absentReason ? absentReason : ''}
              </div>
            }
          </Row>
          {rejectAllowed === true &&
            <Row>
              <Col md='auto'>
                <ButtonTheme type='submit' variant="filled" color='#f5f5f5' className='mt-4' onClick={() => setReasonModal(false)}>
                  Cancel
                </ButtonTheme>
              </Col>
              <Col md='auto'>
                <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => { shiftAction() }}>
                  Reject
                </ButtonTheme>
              </Col>
            </Row>}
        </Modal.Body>
      </Modal>
    </>
  )
}

export default CancelledAssignments